import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cc16234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-main" }
const _hoisted_2 = { class: "main-content pdf-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-column-center pt42 pb38" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "pdf-title" }, "PDF加密分享"),
  /*#__PURE__*/_createElementVNode("p", { class: "pdf-desc mt10" }, "上传文件>设置加密方式>分享链接")
], -1))

import { ref, reactive, defineAsyncComponent } from "vue";
import checkPc from '@/utils/checkPc'
import { useRoute, useRouter } from "vue-router"


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const router = useRouter()

/**
 * 判断是否PC端
 */
const isPC = checkPc()

// 引入组件
const Container = defineAsyncComponent(() => import("@/views/home/components/container.vue"));
const Encryption = defineAsyncComponent(() => import("./components/Encryption.vue"));
const UploadView = defineAsyncComponent(() => import("./components/UploadView.vue"));
const SetFileForm = defineAsyncComponent(() => import("@/components/SetFileForm.vue"));

// const fileIds = ref('')
const fileList= ref([])

const changeFile = (data: any) => {
  let newArray = data.filter((item: any) => item.data)
  newArray = newArray.map((item: any) => {
    const { name, size } = item
    return { title: name, url: item.data.name, file_size: size }
  })
  if (newArray.length === data.length) fileList.value = newArray
  else fileList.value = []
}

// 加密成功
const encryptSuccess = (e:any) => {
  console.log(fileList.value, 'fileList.value')
  router.push({ name: 'pdf-result', params: { ids: e } })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(UploadView), { onChangeFile: changeFile })
    ]),
    _createVNode(_unref(Container), {
      class: "pt34 pb20",
      title: "加密设置"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SetFileForm), {
          fileList: fileList.value,
          onSuccess: encryptSuccess
        }, null, 8, ["fileList"])
      ]),
      _: 1
    }),
    _createVNode(_unref(Encryption))
  ]))
}
}

})